import {Flex, Heading, Icon, Stack, StackProps} from "@chakra-ui/react";
import {
  HoverMenuItem,
  HoverMenuItemHeading,
  HoverMenuItemText,
  HoverMenuList,
  HoverMenuSection,
  HoverMenuSeparator,
} from "../components/HoverMenu";
import {ReactNode} from "react";
import {DocumentTextIcon, NewspaperIcon} from "@heroicons/react/24/outline";

const SectionHeading = ({children}: {children: ReactNode}) => (
  <Heading size="xs" textTransform="uppercase">
    {children}
  </Heading>
);

const About = (props: StackProps) => (
  <HoverMenuList {...props}>
    <Stack separator={<HoverMenuSeparator />} gap={4}>
      <HoverMenuItem px={6} py={2} className="group">
        <Flex w={8} h={8} p={1.5} rounded="md" flexShrink={0} bgGradient="blueBrand" align="center" justify="center">
          <Icon asChild fontSize="xl">
            <NewspaperIcon />
          </Icon>
        </Flex>
        <Stack gap={1}>
          <HoverMenuItemHeading to="/blog">Blog</HoverMenuItemHeading>
          <HoverMenuItemText>
            Platformed&apos;s perspectives on due diligence, procurement &amp; enterprise sales
          </HoverMenuItemText>
        </Stack>
      </HoverMenuItem>
      <HoverMenuSection heading={<SectionHeading>eGuides</SectionHeading>}>
        <HoverMenuItem className="group">
          <Flex w={8} h={8} p={1.5} rounded="md" flexShrink={0} bgGradient="respondMin" align="center" justify="center">
            <Icon asChild fontSize="xl">
              <DocumentTextIcon />
            </Icon>
          </Flex>
          <Stack gap={1}>
            <HoverMenuItemHeading to="/guide-to-eu-ai-act-for-enterprise-governance">EU AI Act</HoverMenuItemHeading>
            <HoverMenuItemText>A guide to due diligence for risk professionals</HoverMenuItemText>
          </Stack>
        </HoverMenuItem>
        <HoverMenuItem className="group">
          <Flex w={8} h={8} p={1.5} rounded="md" flexShrink={0} bgGradient="respondMin" align="center" justify="center">
            <Icon asChild fontSize="xl">
              <DocumentTextIcon />
            </Icon>
          </Flex>
          <Stack gap={1}>
            <HoverMenuItemHeading to="/guide-to-dora-third-party-risk-management">DORA eGuide</HoverMenuItemHeading>
            <HoverMenuItemText>Considerations for third-party risk management</HoverMenuItemText>
          </Stack>
        </HoverMenuItem>
      </HoverMenuSection>
    </Stack>
  </HoverMenuList>
);
export default About;
